// ------------------------------------------------
// Helper Functions
// ------------------------------------------------

if (document.querySelector('#footerDate')) {
  document.querySelector('#footerDate').innerHTML = new Date().getFullYear();
}

// Make foreach functions play nice with query selector all
const forEachAll = function (array, callback, scope) {
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, i, array[i]); // passes back stuff we need
  }
};

// A simeple check to see if element exists
const doIexist = function (element, callback) {
  if (document.querySelector(element)) {
    callback();
  }
};

// checks if element has a class
function hasClass(element, cls) {
  return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
}

// Event on keyup
const onReturn = function (element, callback) {
  element.addEventListener('keyup', function (e) {
    callback(e);
  });
};

// Event on click
const clickEvt = (element, callback) => {
  element.addEventListener('click', function (e) {
    callback(e);
  });
};

// Remove all class
const toggleClasses = function (mode = 'add', elementArry, classToRemove) {
  if (mode === 'add') {
    forEachAll(elementArry, function (index) {
      elementArry[index].classList.add(classToRemove);
    });
  } else if (mode === 'remove') {
    forEachAll(elementArry, function (index) {
      elementArry[index].classList.remove(classToRemove);
    });
  } else if (mode === 'toggle') {
    forEachAll(elementArry, function (index) {
      elementArry[index].classList.toggle(classToRemove);
    });
  }
};

// IE 10 fix for window location origin
if (!window.location.origin) {
  window.location.origin =
    window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '');
}

// remove item from array based on value
Array.prototype.remove = function () {
  var what,
    a = arguments,
    L = a.length,
    ax;
  while (L && this.length) {
    what = a[--L];
    while ((ax = this.indexOf(what)) !== -1) {
      this.splice(ax, 1);
    }
  }
  return this;
};

// ------------------------------------------------
// Global Variables
// ------------------------------------------------
const pglobals = {
  pHref: window.location.href.toLowerCase(),
  pOrigin: window.location.origin.toLowerCase(),
  body: document.querySelector('body'),
  settings: {
    speedClose: 200,
    speedOpen: 500,
  },
  mobile: false,
  checkmobile() {
    if (window.innerWidth < 768) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  },
  // look at an array of urls and see it the current url matches one
  checkforurl: (arr) => {
    let urlexists = false;
    forEachAll(arr, function (index) {
      if (pglobals.pHref.indexOf(arr[index].toLowerCase()) !== -1) {
        urlexists = true;
      }
    });
    return urlexists;
  },
  // detect if using bs2 template
  bs2AppDetect() {
    if (document.querySelector('.bs2-layout')) {
      return true;
    } else {
      return false;
    }
  },
  // dectect section of app by url
  appSectionDetect() {
    let pagesection = '';

    const pagesHeadless = [
        'providers/medicalpolicy.aspx',
        'providers/coverage_policy.aspx',
        'providers/paymentpolicy_search.aspx',
        'providers/additional_coverage_association.aspx',
        'providers/primary_coverage_criteria_association.aspx',
        'providers/EPA/IPStatus.aspx',
        'members/HDCIntro.aspx',
        'providers/pre_disclaimer.aspx',
        'providers/generalprecert.aspx',
        'providers/MPreCertRouter.aspx',
        'providers/router_disclaimer.aspx',
        'providers/BAAOtherMedicalPolicy.aspx',
        'providers/BAAMedicalpolicy.aspx',
        'providers/invalid_page.aspx',
        'providers/medical-providers/coverage-policy/additional-information',
        'providers/medical-providers/coverage-policy/primary-coverage-criteria',
        'no-head',
      ],
      pagesEmployers = [
        'employers',
        'lookingforinsurance',
        'plans_products',
        'employers/sbc.aspx',
        'lookingforinsurance/RequestAssistance.aspx',
      ],
      pagesShopping = [
        'members/OEP_options.aspx',
        'lookingforinsurance/OEP_options.aspx',
        'lookingforinsurance/aep_oep.aspx',
      ],
      pagesProviders = [
        'providers',
        'providers/ediservices_mailinglist.aspx',
        'providers/PFFFSTermandConditions.aspx',
      ],
      pagesContact = [
        'contact',
        'customer_service',
        'health_plans/info_pack.aspx',
        'health_plans/Info_Pack_details.aspx',
      ],
      pagesMembers = ['members', 'bs2'],
      pagesFindcare = ['healthcare-providers', 'bs2-providers'];

    if (this.checkforurl(pagesHeadless)) {
      pagesection = 'headless';
    } else if (this.checkforurl(pagesShopping)) {
      pagesection = 'shop';
    } else if (this.checkforurl(pagesFindcare)) {
      pagesection = 'healthcare-providers';
    } else if (this.checkforurl(pagesMembers)) {
      pagesection = 'members';
    } else if (this.checkforurl(pagesEmployers)) {
      pagesection = 'employers';
    } else if (this.checkforurl(pagesContact)) {
      pagesection = 'support';
    } else if (this.checkforurl(pagesProviders)) {
      pagesection = 'providers';
    }
    return pagesection;
  },
};

pglobals.checkmobile();
window.addEventListener('resize', () => {
  pglobals.checkmobile();
});

// ====---------------====
// Fix skip links
// ====---------------====
window.addEventListener(
  'hashchange',
  () => {
    var focusElement = document.getElementById(location.hash.substring(1));

    if (focusElement) {
      if (!/^(?:a|select|input|button|textarea)$/i.test(focusElement.tagName)) {
        focusElement.tabIndex = -1;
      }

      focusElement.focus();
    }
  },
  false
);

// ------------------------------------------------
// Cludo results url
// ------------------------------------------------
let cludoresultsurl = 'https://arkansasbluecross.com';

const domainList = [
  {
    primary: 'https://arkansasbluecross.com',
    urls: [
      'https://secure.arkansasbluecross.com',
      'https://www.arkansasbluecross.com',
      'https://arkansasbluecross.com',
    ],
  },
  {
    primary: 'https://stg.arkansasbluecross.com',
    urls: ['https://stg.arkansasbluecross.com'],
  },
  {
    primary: 'https://aut.arkansasbluecross.com',
    urls: ['https://aut.arkansasbluecross.com'],
  },
  {
    primary: 'https://healthadvantage-hmo.com',
    urls: [
      'https://secure.healthadvantage-hmo.com',
      'https://www.healthadvantage-hmo.com',
      'https://healthadvantage-hmo.com',
    ],
  },
  {
    primary: 'https://stg.healthadvantage-hmo.com',
    urls: ['https://stg.healthadvantage-hmo.com'],
  },
  {
    primary: 'https://aut.healthadvantage-hmo.com',
    urls: ['https://aut.healthadvantage-hmo.com'],
  },
  {
    primary: 'https://arkansasoctave.com',
    urls: [
      'https://secure.arkansasoctave.com',
      'https://www.arkansasoctave.com',
      'https://arkansasoctave.com',
    ],
  },
  {
    primary: 'https://stg.arkansasoctave.com',
    urls: ['https://stg.arkansasoctave.com'],
  },
  {
    primary: 'https://aut.arkansasoctave.com',
    urls: ['https://aut.arkansasoctave.com'],
  },
  {
    primary: 'https://blueadvantagearkansas.com',
    urls: [
      'https://secure.blueadvantagearkansas.com',
      'https://www.blueadvantagearkansas.com',
      'https://blueadvantagearkansas.com',
    ],
  },
  {
    primary: 'https://stg.blueadvantagearkansas.com',
    urls: ['https://stg.blueadvantagearkansas.com'],
  },
  {
    primary: 'https://aut.blueadvantagearkansas.com',
    urls: ['https://aut.blueadvantagearkansas.com'],
  },
];

domainList.forEach((domain) => {
  domain.urls.forEach((url) => {
    if (pglobals.pOrigin === url) {
      cludoresultsurl = domain.primary;
    }
  });
});

// ------------------------------------------------
// JQuery Stuff
// ------------------------------------------------
// Bootstrap js setup
if (!pglobals.bs2AppDetect()) {
  jQuery(function ($) {
    if ($('[data-toggle="tooltip"]')) {
      $('[data-toggle="tooltip"]').tooltip();
    }
    if ($('[data-toggle="popover"]')) {
      $('[data-toggle="popover"]').popover();
    }
    $('#carouselnotice').carousel({
      interval: false,
    });
    $('#carouselalert').carousel({
      interval: false,
    });
    $('#carouselTestimonials').carousel({
      interval: false,
    });

    if (document.querySelector('#carouselHero')) {
      $('#carouselHero').carousel({
        interval: false,
      });
    }

    if (window.location.hash.toLowerCase() === '#modallinkingdisclaimer') {
      $('#modalLinkingDisclaimer').modal();
    }
  });
} else {
  jQuery(function ($) {
    $('[data-toggle="popover"]').popover();
    $('[data-toggle="tooltip"]').tooltip();
  });
}

// ====---------------====
// IE Modal
// ====---------------====

jQuery(function ($) {
  // ====---------------====
  // Toggle bootstrap accordion open based on hash
  // ====---------------====
  let pageHash = window.location.hash;
  if (document.querySelector('.card')) {
    if (pageHash && document.querySelector(pageHash)) {
      $(window.location.hash).collapse('toggle');
    } else if (document.querySelector('#officelocations')) {
      if (pageHash === '#fayetteville') {
        $('#officelocations1').collapse('toggle');
      } else if (pageHash === '#fort-smith') {
        $('#officelocations2').collapse('toggle');
      } else if (pageHash === '#hot-springs') {
        $('#officelocations3').collapse('toggle');
      } else if (pageHash === '#jonesboro') {
        $('#officelocations4').collapse('toggle');
      } else if (pageHash === '#little-rock') {
        $('#officelocations5').collapse('toggle');
      } else if (pageHash === '#pine-bluff') {
        $('#officelocations6').collapse('toggle');
      } else if (pageHash === '#texarkana') {
        $('#officelocations7').collapse('toggle');
      }
    }
  }

  if (document.querySelector('[data-dismiss-link="modal"]')) {
    $('[data-dismiss-link="modal"]').on('click', function () {
      $(this).closest('.modal').modal('hide');
    });
  }

  $('[data-toggle="collapseHide"]').each(function (index) {
    $(this).on('click', function () {
      let collapseId = $(this).attr('data-target');
      $(collapseId).collapse('hide');
    });
  });

  $('.radio[data-toggle="collapse"]').each(function (index) {
    if ($(this).find('input').prop('checked')) {
      let collapseId = $(this).attr('data-target');
      $(collapseId).collapse('show');
    }
  });

  $('input[data-toggle="collapse"]').each(function (index) {
    if ($(this).prop('checked')) {
      let collapseId = $(this).attr('data-target');
      $(collapseId).collapse('show');
    }
  });

  // ====---------------====
  // Masking
  // ====---------------====
  if (document.querySelector('.mask-date')) {
    $('.mask-date').inputmask('99/99/9999');
  }
  if (document.querySelector('.mask-ssn')) {
    $('.mask-ssn').inputmask('999-99-9999');
  }
  if (document.querySelector('.mask-taxid')) {
    $('.mask-taxid').inputmask('99-9999999');
  }
  if (document.querySelector('.mask-zip')) {
    $('.mask-zip').inputmask('99999');
  }
  if (document.querySelector('.mask-expire')) {
    $('.mask-expire').inputmask('99/99');
  }
  if (document.querySelector('.mask-phone')) {
    $('.mask-phone').inputmask({
      regex: '[2-9]\\d{2}-\\d{3}-\\d{4}',
    });
  }
  if (document.querySelector('.mask-tel')) {
    $('.mask-tel').inputmask('(999) 999-9999');
  }

  // ====---------------====
  // IE Bad modal
  // ====---------------====
  if (document.querySelector('#IeBad')) {
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    document
      .querySelector('#IeBad .close')
      .addEventListener('click', function (e) {
        e.preventDefault();
        sessionStorage.setItem('hideIeBadModal', true);
        jQuery('#IeBad').modal('hide');
      });

    document
      .querySelector('#IeBad .btn-primary')
      .addEventListener('click', function (e) {
        e.preventDefault();
        sessionStorage.setItem('hideIeBadModal', true);
        jQuery('#IeBad').modal('hide');
      });

    if (
      isIE11 &&
      document.querySelector('#IeBad') &&
      !sessionStorage.getItem('hideIeBadModal')
    ) {
      jQuery('#IeBad').modal('show');
    }
  }
});

// ------------------------------------------------
// Bootstrap 2 site checks
// ------------------------------------------------
// Check if page is part of the provider directory and if so add the correct stylesheet
const providerPages = () => {
  let csslinkpath = document.createElement('link');
  csslinkpath.type = 'text/css';
  csslinkpath.rel = 'stylesheet';

  const checkLive = function checkIfLiveOrTest() {
    if (pglobals.pOrigin.indexOf('tsslhealthadvantage') !== -1) {
      return true;
    } else if (pglobals.pOrigin.indexOf('tsslblueadvantage') !== -1) {
      return true;
    } else if (pglobals.pOrigin.indexOf('tsslarkbluecross') !== -1) {
      return true;
    } else {
      return false;
    }
  };

  if (checkLive()) {
    csslinkpath.href =
      'https://sarkbluecross2/ResourcePackages/ArkBlueCross/theme/corp/css/pd-fonts.css';
  } else if (pglobals.pHref.indexOf('bs2-providers-directory') !== -1) {
    csslinkpath.href = './assets/css/pd-fonts.css';
  } else {
    csslinkpath.href =
      'https://www.arkansasbluecross.com/ResourcePackages/ArkBlueCross/theme/corp/css/pd-fonts.css';
  }
  document.head.appendChild(csslinkpath);
};

// Look at what bs2 section and add the class for the proper layout / sidebar
const bs2Pages = () => {
  switch (pglobals.appSectionDetect()) {
    case 'healthcare-providers':
      providerPages();
      pglobals.body.classList.add('bs2-layout--pd');
      break;
    case 'members':
      pglobals.body.classList.add('bs2-layout--sidebar');
      document.querySelector('#sn-members').classList.add('active');
      break;
    case 'employers':
      pglobals.body.classList.add('bs2-layout--sidebar');
      document.querySelector('#sn-employers').classList.add('active');
      break;
    case 'providers':
      pglobals.body.classList.add('bs2-layout--sidebar');
      document.querySelector('#sn-providers').classList.add('active');
      break;
    case 'support':
      pglobals.body.classList.add('bs2-layout--sidebar');
      document.querySelector('#sn-support').classList.add('active');
      break;
    case 'shop':
      pglobals.body.classList.add('bs2-layout--sidebar');
      document.querySelector('#sn-shop').classList.add('active');
      break;
    case 'headless':
      pglobals.body.classList.add('bs2-layout--headless');
      document
        .querySelector('.site-footer')
        .classList.add('site-footer--headless');
      break;
    default:
      break;
  }
};

if (pglobals.bs2AppDetect()) {
  bs2Pages();
}

// ====---------------====
// Dark mode
// ====---------------====
let isMedicarePage = false;
let themeCookie = false;
const themeToggle = document.querySelector('.sm__toggle');

if (document.querySelector('.content--medicare')) {
  isMedicarePage = true;
}

function setThemeCookie(mode) {
  localStorage.setItem('abcbs-theme', mode);
}

if (localStorage.getItem('abcbs-theme') === 'dark') {
  themeCookie = 'dark';
} else if (localStorage.getItem('abcbs-theme') === 'light') {
  themeCookie = 'light';
}

if (themeToggle && !isMedicarePage) {
  if (themeCookie === 'dark') {
    document.body.setAttribute('data-theme', 'dark');
    themeToggle.querySelector('input').checked = true;
  } else if (themeCookie === 'light') {
    document.body.setAttribute('data-theme', 'light');
  } else {
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches
    ) {
      document.body.setAttribute('data-theme', 'dark');
    } else {
      document.body.setAttribute('data-theme', 'light');
    }
  }

  const ttInput = document.querySelector('.sm__toggle input');
  ttInput.addEventListener('change', function (e) {
    if (document.body.getAttribute('data-theme') === 'light') {
      document.body.setAttribute('data-theme', 'dark');
      setThemeCookie('dark');
    } else {
      document.body.setAttribute('data-theme', 'light');
      setThemeCookie('light');
    }
  });
}

// ------------------------------------------------
// Header Toggles
// ------------------------------------------------
// Opens and closes sections of the header
const toggleHeader = {
  openTriggers: document.querySelectorAll('[data-toggle-class]'),
  closeTriggers: document.querySelectorAll('[data-toggle-close]'),
  openClasses: ['js-sm-open', 'js-search-open', 'js-sign-open'],
  settings: {
    speedClose: 200,
    speedOpen: 500,
  },
  open: function (_element) {
    const tclass = _element.getAttribute('data-toggle-class'),
      elAriaId = _element.getAttribute('data-aria-id'),
      elAriaTitle = _element.getAttribute('data-aria-title'),
      _body = document.querySelector('body'),
      openClasses = this.openClasses;

    let coState = false;
    let _closeEl;

    forEachAll(openClasses, function (index) {
      if (hasClass(_body, openClasses[index]) && openClasses[index] != tclass) {
        coState = true;
        _closeEl = document.querySelector(
          '[data-toggle-class=' + openClasses[index] + ']'
        );
      }
    });

    const openMain = function () {
      // isn't open add open class
      _body.classList.add(tclass);

      // add aria-expanded
      _element.setAttribute('aria-expanded', true);
      console.log(_element);

      // Add aria mesage to region
      document.querySelector('#' + elAriaId).innerHTML =
        elAriaTitle + ' opened. Navigate to the content below.';

      // add animate class then clear post animation
      _body.classList.add('js-animate-in');
      setTimeout(() => {
        _body.classList.remove('js-animate-in');

        if (hasClass(_body, 'js-search-open')) {
          document.getElementById('siteSearchInput').focus();
        } else if (hasClass(_body, 'js-sign-open')) {
          document.getElementById('loginUser').focus();
        }
      }, toggleHeader.settings.speedClose);
    };

    // Checking if already open or not
    if (!hasClass(_body, tclass)) {
      if (coState) {
        this.close(_closeEl);

        setTimeout(() => {
          openMain();
        }, toggleHeader.settings.speedClose);
      } else {
        openMain();
      }
    } else {
      this.close(_element);
    }
  },
  close: function (_element) {
    const tclass = _element.getAttribute('data-toggle-class'),
      elAriaId = _element.getAttribute('data-aria-id'),
      elAriaTitle = _element.getAttribute('data-aria-title'),
      _body = document.querySelector('body');

    if (hasClass(_body, tclass)) {
      // aria-expanded to false
      _element.setAttribute('aria-expanded', false);

      // Add aria message to region
      document.querySelector('#' + elAriaId).innerHTML =
        elAriaTitle + ' closed.';

      // add animate class then clear post animation
      _body.classList.add('js-animate-out');
      setTimeout(() => {
        _body.classList.remove(tclass);
        _body.classList.remove('js-animate-out');
      }, toggleHeader.settings.speedClose);
    }
  },
  bindOpen: function () {
    forEachAll(toggleHeader.openTriggers, function (index) {
      toggleHeader.openTriggers[index].addEventListener('click', function () {
        toggleHeader.open(this);
      });
    });
  },
  bindClose: function () {
    forEachAll(toggleHeader.closeTriggers, function (index) {
      toggleHeader.closeTriggers[index].addEventListener('click', function () {
        const _body = document.querySelector('body');
        let bcOpens = toggleHeader.openClasses;

        forEachAll(bcOpens, function (index) {
          if (hasClass(_body, bcOpens[index])) {
            let bcButton = document.querySelector(
              '[data-toggle-class=' + bcOpens[index] + ']'
            );

            _body.classList.remove(bcOpens[index]);
            bcButton.setAttribute('aria-expanded', false);
            if (bcOpens[index] === 'js-sm-open') {
              document
                .querySelector('.sm__menu')
                .setAttribute('aria-expanded', false);
            } else {
              bcButton.nextElementSibling.setAttribute('aria-expanded', false);
            }
          }
        });
      });
    });
  },
  escClose: function () {
    window.addEventListener('keyup', function (event) {
      if (event.keyCode === 27) {
        let openItem = document.querySelector(
          '[data-toggle-class][aria-expanded="true"]'
        );
        toggleHeader.close(openItem);
      }
    });
  },
  gogo: function () {
    toggleHeader.bindClose();
    toggleHeader.bindOpen();
    toggleHeader.escClose();
  },
};
toggleHeader.gogo();

// ------------------------------------------------
// Search Results Search
// ------------------------------------------------
if (pglobals.pHref.indexOf('search-results') !== -1) {
  document.querySelector('body').classList.add('js-search-results-open');
}

// ====---------------====
// Widths to ems conversion
// ====---------------====
const widthEms = function (pxWidth) {
  // gets the browser font setting
  const browserFs = window
    .getComputedStyle(document.body, null)
    .getPropertyValue('font-size');
  // converts width prop to ems based on 16px (normal browser default)
  const widthBase = pxWidth / 16;
  // takes the ems amount and then converts that to px based on the new size
  const convertedWidth = widthBase * parseInt(browserFs);

  return convertedWidth;
};

// ------------------------------------------------
// Simple Accordion
// ------------------------------------------------
const SimepleAccordion = function () {
  const saTargets = document.querySelectorAll('[data-saccordion]');

  function findBtns(saEl, saId) {
    const saBtns = saEl.querySelectorAll(
      '.as__btn[data-parent="' + saId + '"]'
    );

    // Clear open buttons
    function clearOpen(elList) {
      forEachAll(elList, function (index) {
        elList[index].parentNode.classList.remove('js-open');
      });
    }

    // bass add remove for open accordions
    forEachAll(saBtns, function (index) {
      saBtns[index].addEventListener('click', function (event) {
        if (window.innerWidth <= widthEms(767)) {
          event.preventDefault();
          if (hasClass(this.parentNode, 'js-open')) {
            this.parentNode.classList.remove('js-open');
          } else {
            clearOpen(saBtns);
            this.parentNode.classList.add('js-open');
          }
        } else {
          if (!hasClass(this.parentNode.parentNode, 'sm__menu')) {
            event.preventDefault();
            if (hasClass(this.parentNode, 'js-open')) {
              this.parentNode.classList.remove('js-open');
            } else {
              clearOpen(saBtns);
              this.parentNode.classList.add('js-open');
            }
          }
        }
      });
    });
  }

  // fires the findbtn func
  forEachAll(saTargets, function (index) {
    let saEl = saTargets[index],
      saId = saEl.getAttribute('data-saccordion');

    findBtns(saEl, saId);
  });
};
SimepleAccordion();

// ------------------------------------------------
// Show mobile subnav
// ------------------------------------------------

// shows extra nav in the hamburger menu when on a mobile layout
const MobileSubNav = {
  subnavs: document.querySelectorAll('[data-subnav-target]'),

  // base show hide functionality for the sub nav
  showhide: function () {
    forEachAll(MobileSubNav.subnavs, function (index) {
      MobileSubNav.subnavs[index].addEventListener('click', function (event) {
        let curEl = this;
        let curAttr = curEl.getAttribute('data-subnav-target');

        if (window.innerWidth <= widthEms(767) || curEl.type === 'submit') {
          event.preventDefault();
          document
            .querySelector('[data-subnav="' + curAttr + '"]')
            .classList.toggle('active');
        }
      });
    });
  },

  // hideing function to use in other outside functions (menu close)
  hide: function () {
    forEachAll(MobileSubNav.subnavs, function (index) {
      let curEl = MobileSubNav.subnavs[index];
      let curAttr = curEl.getAttribute('data-subnav-target');
      document
        .querySelector('[data-subnav="' + curAttr + '"]')
        .classList.remove('active');
    });
  },
};
MobileSubNav.showhide();

// ====---------------====
// dropdown menus
// ====---------------====
// addes a class letting so that screen readers can use drop down menus
if (document.querySelector('a.dropdown')) {
  const dropdowns = document.querySelectorAll('a.dropdown'),
    dropdownsSub = document.querySelectorAll('a.dropdown ~ ul li'),
    dropdownOff = (element) => {
      element.classList.remove('js-active');
      element.querySelector('.dropdown').setAttribute('aria-expanded', false);
      element.querySelector('ul').setAttribute('aria-expanded', false);
    },
    dropdownOn = (element) => {
      element.classList.add('js-active');
      element.querySelector('.dropdown').setAttribute('aria-expanded', true);
      element.querySelector('ul').setAttribute('aria-expanded', true);
    },
    dropdownsClearAll = () => {
      forEachAll(dropdowns, (index) => {
        dropdownOff(dropdowns[index].parentNode);
      });
    };

  forEachAll(dropdowns, (index) => {
    const dropEl = dropdowns[index];

    // closes dropdown when mouse leaves
    dropEl.parentNode.addEventListener('mouseleave', function () {
      if (dropEl.parentNode.querySelector('ul')) {
        dropdownOff(this);
      }
    });

    // opens dropdown when mouse enters
    dropEl.parentNode.addEventListener('mouseenter', function () {
      if (dropEl.parentNode.querySelector('ul')) {
        dropdownOn(this);
      }
    });

    // opens drop down when dropdown link is focused
    dropdowns[index].addEventListener('focus', function () {
      // hides other open dropdowns
      dropdownsClearAll();

      dropdownOn(this.parentNode);
      // Checking to see if there are no more parent nodes aka menu items
      if (this.parentNode.querySelector('.dropdown-col')) {
        //Selecting the links in the submenus
        const lastNav = this.parentNode.querySelectorAll('a');
        //Adding a event listener to listen to when focus leaves the last link item in the submenus to clear the dropdowns
        lastNav[lastNav.length - 1].addEventListener('focusout', function () {
          dropdownsClearAll();
        });
      }
    });

    // closing dropdown when esc key is hit
    dropEl.parentNode.addEventListener('keyup', function (evt) {
      // Checking to see if they escape keycode is clicked
      if (evt.keyCode == 27) {
        // clearing all dropdowns if it is
        dropdownsClearAll();
      }
    });
  });

  // checks for if users is blurring out of dropdown menu
  // by watching for a blur event on the last dropdown sub menu link
  forEachAll(dropdownsSub, (index) => {
    let el = dropdownsSub[index],
      ela = dropdownsSub[index].querySelector('a');

    ela.addEventListener('blur', function () {
      if (el.nextElementSibling === null) {
        dropdownOff(el.parentNode.parentNode);
      }
    });
  });
}

// ====---------------====
// Featured nav modal check
// ====---------------====
if (document.querySelector('.featured-nav')) {
  let modalsArry = document.querySelectorAll('.modal');
  forEachAll(modalsArry, function (index) {
    let modalId = modalsArry[index].getAttribute('id');
    if (document.querySelector(`a[href="/medicare#${modalId}"]`)) {
      jQuery(`a[href = "/medicare#${modalId}"]`).on('click', function (e) {
        e.preventDefault();
        jQuery('#' + modalId).modal('show');
      });
    }
  });
}

if (document.querySelector('.sm__list li a[href="#medicare-shop-year"]')) {
  let medShopLink = document.querySelector(
      '.sm__list li a[href="#medicare-shop-year"]'
    ),
    medShopModalId = medShopLink.getAttribute('href');

  medShopLink.addEventListener('click', function (e) {
    e.preventDefault();
    jQuery(medShopModalId).modal();
  });
}

// ====---------------====
// Disables click on top level nav items that don't have #0
// ====---------------====
if (document.querySelector('.featured-nav--medicare')) {
  const navEls = document.querySelectorAll('.featured-nav--medicare > li > a');

  forEachAll(navEls, function (index) {
    if (
      navEls[index].getAttribute('href').indexOf('medicare-nav/members') ===
        1 ||
      navEls[index].getAttribute('href').indexOf('medicare-nav/learn') === 1
    ) {
      navEls[index].addEventListener('click', function (e) {
        e.preventDefault();
      });
    }
  });
}

// ------------------------------------------------
// File Input
// ------------------------------------------------
// Support for a custom designed file input to show selected file
const fileInput = (element) => {
  const fileName = element
      .querySelector('input[type=file]')
      .value.split('\\')
      .pop(),
    inputOHeight = element.querySelector('.input-file-txt').offsetHeight,
    inputCHeight = element.querySelector('.input-file-txt').clientHeight,
    inputHeight = inputOHeight + inputCHeight + 'px';

  element.querySelector('.input-file-txt span').innerHTML = fileName;
  element.querySelector('.input-file-txt span').style.height = inputHeight;

  if (element.querySelector('.input-file-txt span').innerHTML.length > 0) {
    element.querySelector('.input-file-btn').innerHTML = 'Edit';
  } else {
    element.querySelector('.input-file-btn').innerHTML = 'Choose file';
  }
};
doIexist('.input-file', function () {
  var fileInputs = document.querySelectorAll('.input-file');

  forEachAll(fileInputs, function (index) {
    fileInputs[index].addEventListener('change', function () {
      fileInput(this);
    });
  });
});

// ------------------------------------------------
// Site Search
// ------------------------------------------------
// Inject Search for into page. This is to prevent issues with aspx
const searchFormInject = function () {
  let searchcontent = document.querySelector('.search__bar').innerHTML;
  let form = `
    <form class="form-search" id="siteSearch" novalidate autocomplete="off">
      <div class="form-group">
        <label for="siteSearchInput" class="sr-only">What can we help you find?</label>
        <input type="text" class="form-control" id="siteSearchInput" required>
        <span class="error-message">Please enter a search term.</span>
        <svg class="icn icn-danger error-icn" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="34.8 34.8 20 20"><title>Exclamation Mark</title><path d="M44.8 34.8c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm1.5 16.7h-3.1v-2.6h3.1v2.6zm-.3-3.8h-2.5l-.7-8.9h3.8l-.6 8.9z"></path></svg>
      </div>
      <input type="submit" value="Search" class="btn btn-secondary">
    </form>
  `;
  document.querySelector('#search-header').innerHTML = form;
};

// capture if the search input is submitted and if so close the search box
const searchInput = function (formid) {
  const form = formid,
    formInput = formid.querySelector('input[type="text"');

  formInput.addEventListener('keyup', function (event) {
    if (event.keyCode != 13) {
      if (formInput.value.length > 0) {
        formInput.parentNode.classList.remove('error');
      }
    } else if (event.keyCode === 13) {
      if (formInput.value.length > 0) {
        let openItem = document.querySelector(
          '[data-toggle-class][aria-expanded="true"]'
        );
        toggleHeader.close(openItem);
      } else {
        event.preventDefault();
        formInput.parentNode.classList.add('error');
      }
    }
  });

  form
    .querySelector('input[type=submit]')
    .addEventListener('click', function () {
      if (formInput.value.length >= 1) {
        formInput.parentNode.classList.remove('error');
        let openItem = document.querySelector(
          '[data-toggle-class][aria-expanded="true"]'
        );
        toggleHeader.close(openItem);
      } else {
        event.preventDefault();
        formInput.parentNode.classList.add('error');
      }
    });
};

var searchGogo = function () {
  return new Promise(function (resolve) {
    resolve(searchFormInject());
  });
};

if (!document.querySelector('.bs2-layout--headless')) {
  searchGogo()
    .then(function () {
      searchInput(document.querySelector('#siteSearch'));
      if (document.querySelector('#siteSearch404')) {
        searchInput(document.querySelector('#siteSearch404'));
      }
    })
    .catch(function (error) {
      window.console.log(error);
    });
}

// ====---------------====
// Watch for Zero search results
// ====---------------====
if (
  document.querySelector('.search-result-count') &&
  !document.querySelector('#e')
) {
  const searchResultsCount = document.querySelector('.search-result-count');

  // Checks on page load for zero search results. This should pretty much never run
  // since the search runs after page load
  if (
    searchResultsCount.querySelector('b:last-of-type') &&
    searchResultsCount.querySelector('b:last-of-type').innerHTML === '0'
  ) {
    window.location = '/zero-results/';
  }

  // watches for changes to the search results number. IF that number is zero
  // then the page will redirect to a zero results found page.
  searchResultsCount.addEventListener('DOMSubtreeModified', () => {
    setTimeout(() => {
      if (
        searchResultsCount.querySelector('b:last-of-type') &&
        searchResultsCount.querySelector('b:last-of-type').innerHTML === '0'
      ) {
        window.location = '/zero-results/';
      }
    }, 500);
  });
}

// ------------------------------------------------
// Site Alert Hide
// ------------------------------------------------
// Add click handler for alert close
if (document.querySelector('.site-alert__close')) {
  document
    .querySelector('.site-alert__close')
    .addEventListener('click', function (e) {
      e.preventDefault();
      sessionStorage.setItem('showalerts', true);
      document.querySelector('.site-alerts').classList.add('hide');
    });
}

// if (document.querySelector('.site-alerts')) {
//   let alertType = document
//     .querySelector('.carousel-item.active')
//     .getAttribute('data-alerttype');
//   if (alertType === 'warning') {
//     document.querySelector('.site-alerts').classList.remove('info');
//     document.querySelector('.site-alerts').classList.add('warning');
//   } else {
//     document.querySelector('.site-alerts').classList.remove('warning');
//     document.querySelector('.site-alerts').classList.add('info');
//   }

//   jQuery('#carouselalert').on('slid.bs.carousel', function() {
//     alertType = document
//       .querySelector('.carousel-item.active')
//       .getAttribute('data-alerttype');
//     if (alertType === 'warning') {
//       document.querySelector('.site-alerts').classList.remove('info');
//       document.querySelector('.site-alerts').classList.add('warning');
//     } else {
//       document.querySelector('.site-alerts').classList.remove('warning');
//       document.querySelector('.site-alerts').classList.add('info');
//     }
//   });
// }

// Check session storage and if hidden hide
if (typeof Storage != 'undefined') {
  if (
    sessionStorage.getItem('showalerts') &&
    document.querySelector('.site-alerts')
  ) {
    document.querySelector('.site-alerts').classList.add('hide');
  }
}

// ------------------------------------------------
// Sticky Header
// ------------------------------------------------
const stickyHeader = function () {
  let lastScrollPosition = 0;
  window.addEventListener('scroll', function () {
    let newScrollPosition = window.scrollY;
    if (newScrollPosition === 0) {
      document.querySelector('body').classList.remove('js-sticky-nav');
    } else if (newScrollPosition < lastScrollPosition) {
      if (!document.querySelector('.js-sticky-nav')) {
        document.querySelector('body').classList.add('js-sticky-nav');
      }
    } else {
      document.querySelector('body').classList.remove('js-sticky-nav');
    }
    lastScrollPosition = newScrollPosition;
  });
};
stickyHeader();

// ------------------------------------------------
// Add target="_blank" (why on earth I have to do this is beyond me)
// TODO - Find a way to do this in SF with Siitefinity instead of JS
// ------------------------------------------------
const stayontarget = {
  pdfs: document.querySelectorAll('a[href*=".pdf"]'),

  init: () => {
    if (document.querySelector('a[href*=".pdf"]')) {
      forEachAll(stayontarget.pdfs, function (index) {
        stayontarget.pdfs[index].setAttribute('target', '_blank');
      });
    }
  },
};
if (document.querySelector('a[href*=".pdf"]')) {
  stayontarget.init();
}

// ------------------------------------------------
// Select Nav - input-group--nav
// ------------------------------------------------
// Enables select nav button once a choice is made
// and then sends you to your chose page
const selectNav = function () {
  const selectmenus = document.querySelectorAll('.input-group--nav');

  forEachAll(selectmenus, function (index) {
    if (selectmenus[index].querySelector('select').value < 1) {
      selectmenus[index].querySelector('.btn').setAttribute('disabled', true);
    }

    selectmenus[index].querySelector('.form-control').onchange = function () {
      if (selectmenus[index].querySelector('select').value < 1) {
        selectmenus[index].querySelector('.btn').setAttribute('disabled', true);
      } else {
        selectmenus[index]
          .querySelector('.input-group-btn .btn')
          .removeAttribute('disabled');
      }
    };

    selectmenus[index]
      .querySelector('.input-group-btn .btn')
      .addEventListener('click', function () {
        window.location.href =
          selectmenus[index].querySelector('.form-control').value;
      });
  });
};

if (document.querySelector('.input-group--nav')) {
  selectNav();
}

// ------------------------------------------------
// Grid Tabs - home page
// ------------------------------------------------
const gridTabs = function () {
  const _navbtns = document.querySelectorAll('button.grid-tab-nav'),
    _navcontent = document.querySelectorAll('.grid-tab-content'),
    // open tabs
    tabOpen = (element, id) => {
      let elAriaTitle = document
        .getElementById(id)
        .getAttribute('data-aria-title');

      document.getElementById('tabs-status').innerHTML =
        elAriaTitle + ' opened. Navigate to the content below.';

      if (!hasClass(element, 'active')) {
        let closeTab = new Promise((resolve) => {
          resolve(tabClose());
        });

        closeTab.then(() => {
          let opendelay = 0;
          let closedelay = 0;

          if (pglobals.mobile) {
            opendelay = pglobals.settings.speedOpen;
          }

          if (pglobals.mobile && hasClass(pglobals.body, 'tab-open')) {
            closedelay = pglobals.settings.speedClose;
          }

          setTimeout(() => {
            pglobals.body.classList.add('js-animate-in');
            element.classList.add('active');
            document.getElementById(id).classList.add('active');
            pglobals.body.classList.add('tab-open');

            setTimeout(() => {
              pglobals.body.classList.remove('js-animate-in');
            }, opendelay);
          }, closedelay);

          if (pglobals.mobile) {
            setTimeout(() => {
              let topOffset = element.getBoundingClientRect().top;
              window.scrollBy(0, topOffset - 53);
            }, 200);
          }
        });
      } else {
        if (pglobals.mobile) {
          tabClose();
        }
      }
    },
    // close tabs
    tabClose = () => {
      let closeSpeed = 0;

      // Check if tab is already open and adjust close speed accordioningly
      if (hasClass(pglobals.body, 'tab-open') && pglobals.mobile) {
        closeSpeed = pglobals.settings.speedClose;
      } else {
        closeSpeed = 0;
      }

      pglobals.body.classList.add('js-animate-out');

      setTimeout(() => {
        toggleClasses('remove', _navbtns, 'active');
        toggleClasses('remove', _navcontent, 'active');
        pglobals.body.classList.remove('tab-open');
        pglobals.body.classList.remove('js-animate-out');
      }, closeSpeed);
    };

  forEachAll(_navbtns, function (index) {
    if (hasClass(_navbtns[index], 'active')) {
      pglobals.body.classList.add('tab-open');
    }

    _navbtns[index].addEventListener('click', function (e) {
      e.preventDefault();

      let tabid = _navbtns[index].getAttribute('data-tab'),
        element = _navbtns[index];

      tabOpen(element, tabid);
    });
  });
};

if (document.querySelector('.grid-tabs')) {
  gridTabs();
}

// ------------------------------------------------
// ID card
// ------------------------------------------------
const idcard = function () {
  const tabs = document.querySelectorAll('.id-card-item');
  const controls = Array.from(
    document.querySelectorAll('.id-card-controls button')
  );
  const svgControls = document.querySelectorAll('.id-card-ex svg a');
  let currentIndex = 0;
  let lastFocusedControl = null; // To track the previously focused control

  function updateIndex() {
    // Ensure only the current tab is focusable
    tabs.forEach((tab) => tab.setAttribute('tabindex', '-1'));
    const currentDescriptionID =
      controls[currentIndex].getAttribute('aria-controls');
    const currentDescription = document.getElementById(currentDescriptionID);
    currentDescription.setAttribute('tabindex', '0');
  }

  function showDescription(control) {
    activateTab(control);
  }

  function activateTab(element) {
    const activeTab = document.getElementById(
      element.getAttribute('aria-controls')
    );

    // Remove active classes and update ARIA states
    toggleClasses('remove', tabs, 'active');
    toggleClasses('remove', svgControls, 'active');
    toggleClasses('remove', controls, 'active');

    tabs.forEach((tab) => tab.setAttribute('aria-selected', 'false'));

    controls.forEach((control) => {
      if (
        control.getAttribute('aria-controls') ===
        element.getAttribute('aria-controls')
      ) {
        control.setAttribute('aria-selected', 'true');
        control.setAttribute('tabindex', '0');
        control.classList.add('active');
      } else {
        control.setAttribute('aria-selected', 'false');
      }
    });

    svgControls.forEach((control) => {
      if (control.getAttribute('href') === `#${activeTab.id}`) {
        control.classList.add('active');
      }
    });

    activeTab.classList.add('active');
    activeTab.setAttribute('aria-selected', 'true');

    // Update status content (optional)
    document.querySelector('#id-status').innerHTML = activeTab.innerHTML;

    // Update focusable descriptions
    updateIndex();
  }

  function toggleClasses(action, elements, className) {
    elements.forEach((element) => {
      element.classList[action](className);
    });
  }

  // Add keyup event listeners for controls
  controls.forEach((control, index) => {
    control.addEventListener('focus', () => {
      currentIndex = index; // Update the current index when a control is focused
      showDescription(control);
    });

    control.addEventListener('keyup', (e) => {
      if (e.key === 'ArrowLeft') {
        // Reset tabindex for the previous control
        if (lastFocusedControl) {
          lastFocusedControl.setAttribute('tabindex', '-1');
        }

        currentIndex =
          currentIndex === 0 ? controls.length - 1 : currentIndex - 1;
        controls[currentIndex].focus();

        // Update last focused control
        lastFocusedControl = controls[currentIndex];
      } else if (e.key === 'ArrowRight') {
        // Reset tabindex for the previous control
        if (lastFocusedControl) {
          lastFocusedControl.setAttribute('tabindex', '-1');
        }

        currentIndex =
          currentIndex === controls.length - 1 ? 0 : currentIndex + 1;
        controls[currentIndex].focus();

        // Update last focused control
        lastFocusedControl = controls[currentIndex];
      }
    });
  });

  // Handle focus transitions when using Tab or Shift+Tab
  document.addEventListener('keyup', (e) => {
    if (e.key === 'Tab') {
      const focusedElement = document.activeElement;

      // Handle Shift+Tab (moving backward)
      if (e.shiftKey) {
        // Check if the focused element is a description
        const focusedIndex = Array.from(tabs).indexOf(focusedElement);
        if (focusedIndex !== -1) {
          // Prevent default Tab behavior
          e.preventDefault();

          // Move focus back to the corresponding control
          controls[focusedIndex].focus();
        }
      }
    }
  });

  // Initialize
  updateIndex();
};

if (document.querySelector('.id-card')) {
  idcard();
}
// ------------------------------------------------
// Add Aria Labels
// ------------------------------------------------

// ===------ Add aria labelledby to sections that aren't a subbanner ------===
if (document.querySelector('section[data-placeholder-label]')) {
  const ariaSections = document.querySelectorAll(
    'section[data-placeholder-label]:not(.subbanner)'
  );

  forEachAll(ariaSections, (index) => {
    let el = ariaSections[index],
      sectionLabel = ariaSections[index].getAttribute('data-placeholder-label');

    el.setAttribute('aria-labelledby', sectionLabel);
  });
}

// ===------ Add aria labelledby to subbanners ------===
if (document.querySelector('section.subbanner[data-placeholder-label]')) {
  const ariaSubbanner = document.querySelectorAll(
    'section.subbanner[data-placeholder-label]'
  );

  forEachAll(ariaSubbanner, (index) => {
    let el = ariaSubbanner[index],
      sectionLabel = ariaSubbanner[index].getAttribute(
        'data-placeholder-label'
      );

    el.setAttribute('aria-label', sectionLabel);
  });
}

// ===------ Add aria-label to sidebar-secondary ------===
if (document.querySelector('.sidebar-secondary[data-placeholder-label]')) {
  const ariaSidebars = document.querySelectorAll(
    '.sidebar-secondary[data-placeholder-label]'
  );

  forEachAll(ariaSidebars, (index) => {
    let el = ariaSidebars[index],
      asideLabel = ariaSidebars[index].getAttribute('data-placeholder-label');

    el.setAttribute('aria-label', asideLabel);
  });
}

// ===------ Add aria-label to side-nav ------===
if (document.querySelector('.side-nav[data-placeholder-label]')) {
  const ariaSideNav = document.querySelector(
      '.side-nav[data-placeholder-label]'
    ),
    ariaSideNavLabel = ariaSideNav.getAttribute('data-placeholder-label');

  ariaSideNav.setAttribute('aria-label', ariaSideNavLabel);
}

// ------------------------------------------------
// Character count
// ------------------------------------------------
if (document.querySelector('.form-group--char-limit')) {
  const fgcharlimit = document.querySelectorAll('.form-group--char-limit');

  forEachAll(fgcharlimit, function (index) {
    let el = fgcharlimit[index],
      txtarea = el.querySelector('textarea'),
      charlimit = el.querySelector('.form-char-limit'),
      charlength = txtarea.getAttribute('maxlength');

    txtarea.addEventListener('keyup', function () {
      let lengthcount = this.value.length;
      let charremaining = 0;
      if (lengthcount > charlength) {
        this.value.substring(0, charlength);
        charremaining = charlength - lengthcount + 1;
      } else {
        charremaining = charlength - lengthcount;
      }
      charlimit.innerHTML = charremaining + ' characters remaining';
    });
  });
}

// ------------------------------------------------
// Select Toggle
// ------------------------------------------------
if (document.querySelector('select[data-toggle="select-toggle-form"]')) {
  const selectToggles = document.querySelectorAll(
    'select[data-toggle="select-toggle-form"]'
  );

  const clearforms = (forms) => {
    forEachAll(forms, (index) => {
      forms[index].classList.remove('js-active');
      forms[index].classList.add('js-hidden');
    });
  };

  forEachAll(selectToggles, (index) => {
    selectToggles[index].addEventListener('change', function () {
      let selectval = this.value,
        selectid = this.getAttribute('id');

      clearforms(
        document.querySelectorAll('.form-group[data-parent="' + selectid + '"]')
      );

      document.querySelector(selectval).classList.remove('js-hidden');
      document.querySelector(selectval).classList.add('js-active');
    });
  });
}

// ====---------------====
// Change phone number to link
// ====---------------====
const changeNumber = (element) => {
  let phoneNum = element.innerHTML,
    phoneStriped = phoneNum.replace(/\D/g, ''),
    phoneNew = document.createElement('a');
  phoneNew.setAttribute('href', `tel:${phoneStriped}`);
  phoneNew.innerHTML = phoneNum;

  element.parentNode.replaceChild(phoneNew, element);
};

const changeNumberLoop = () => {
  if (pglobals.mobile === true) {
    const phoneNumArry = document.querySelectorAll('.phone-mobile');

    forEachAll(phoneNumArry, (index) => {
      changeNumber(phoneNumArry[index]);
    });
  }
};

changeNumberLoop();

window.addEventListener('resize', () => {
  changeNumberLoop();
});

// ====---------------====
// Radio selector
// ====---------------====
if (document.querySelector('[data-radio-select]')) {
  const radioSelects = document.querySelectorAll('[data-radio-select]');

  forEachAll(radioSelects, (index) => {
    radioSelects[index].addEventListener('click', function (e) {
      let curRadioId = this.getAttribute('data-radio-select');

      forEachAll(radioSelects, (indexsub) => {
        let hideId = radioSelects[indexsub].getAttribute('data-radio-select');
        document.querySelector('#' + hideId).classList.add('d--hidden');
      });

      document.querySelector('#' + curRadioId).classList.remove('d--hidden');
    });
  });
}

// ====---------------====
// iframe height adjust
// ====---------------====

if (document.querySelector('#iframe-container')) {
  window.addEventListener(
    'message',
    (e) => {
      let scroll_height = e.data;

      document.getElementById('iframe-container').style.height =
        scroll_height + 'px';
    },
    false
  );
}

// ====---------------====
// Group maps
// ====---------------====
const groupMap = {
  territories: document.querySelectorAll('.group-map g[class*="territory"'),
  show: (modalId) => {
    jQuery('#' + modalId).modal('show');
  },
  binding: () => {
    let territories = groupMap.territories;
    forEachAll(territories, (index) => {
      let territory = territories[index],
        territoryId = territory.classList[0];

      territory.addEventListener('click', () => {
        groupMap.show(territoryId);
      });
    });
  },
  gogo: () => {
    groupMap.binding();
  },
};
if (document.querySelector('.group-map')) {
  groupMap.gogo();
}

// ====---------------====
// Medicare county map
// ====---------------====
const medCountyMap = {
  groupData: {},
  mapId: '',
  countyGroups: {},
  sorting: false,

  // builds the <li>'s for the group list
  countyList: function (group) {
    const countyArry = this.countyGroups[group];
    let html = ``;

    for (let i = 0; i < countyArry.length; i++) {
      html += `<li>${countyArry[i]}</li>`;
    }

    return html;
  },

  // creates and injects the HTML for the group list
  groupList: function () {
    const listContainer = document.querySelector(
        `[data-mapParent=${this.mapId}]`
      ),
      groups = this.countyGroups;
    let colHtml = '';

    for (const group in groups) {
      if (
        this.groupData[group] != undefined &&
        this.groupData[group].length > 0
      ) {
        const listItems = this.countyList(group);

        if (this.sorting === 'by-county') {
          colHtml += `<div class="mgl-col">
            <h3>${this.countyGroups[group][0]}</h3>
            <a href="${this.groupData[group][0]}">View ${this.groupData[group][1]} plans</a>
            </div>`;
        } else {
          colHtml += `<div class="mgl-col">
            <h3>${this.groupData[group][1]}</h3>
            <ul class="list-unstyled">
            ${listItems}
            </ul>
            <a href="${this.groupData[group][0]}">View ${this.groupData[group][1]} plans</a>
            </div>`;
        }
      }
    }

    listContainer.innerHTML = colHtml;
  },

  // Sets a group id on the SVG's g elements based on county group
  mapSetCountyGroup: function (county, groupId) {
    if (this.sorting === 'by-county') {
      const countyEl = document.querySelector(
        `[data-mapId="${this.mapId}"] .${county}`
      );
      const countyUrl = this.groupData[groupId][0];

      countyEl.setAttribute('data-groupid', `group${groupId}`);

      countyEl.addEventListener('click', () => {
        window.location.href = countyUrl;
      });
    } else {
      const countyEl = document.querySelector(
        `[data-mapId="${this.mapId}"] .${county}`
      );
      const countyUrl = this.groupData[groupId][0];
      countyEl.setAttribute('data-groupid', 'group' + groupId);

      countyEl.addEventListener('click', () => {
        window.location.href = countyUrl;
      });
    }
  },

  // removes spaces and periods from county names
  cleanString: function (term) {
    return term.replace(/\s/g, '').replace(/\./g, '').toLowerCase();
  },

  // loops the county groups and fires the map set function
  loopGroups: function () {
    const groups = this.countyGroups;

    for (const group in groups) {
      const groupArry = groups[group];

      if (groupArry.length > 0 && groupArry != undefined) {
        for (let i = 0; i < groupArry.length; i++) {
          const county = this.cleanString(groupArry[i]);
          this.mapSetCountyGroup(county, group);
        }
      }
    }
  },

  // starts all map functions
  init: function (obj, data, id, sorting) {
    // set data
    this.groupData = data;
    this.mapId = id;
    this.countyGroups = obj;
    this.sorting = sorting;

    // fire functions
    this.groupList();
    this.loopGroups();
  },
};

if (document.querySelector('.medicare-map')) {
  const medMaps = document.querySelectorAll('.medicare-map');
  forEachAll(medMaps, (index) => {
    const medMapString = medMaps[index],
      medMapId = medMapString.getAttribute('data-mapId'),
      medMapObj = window[medMapString.getAttribute('data-mapObj')];

    medCountyMap.init(medMapObj.countyGroups, medMapObj.groupData, medMapId);
  });
}

if (document.querySelector('.medicare-map--county')) {
  const medMapsCounty = document.querySelectorAll('.medicare-map--county');
  forEachAll(medMapsCounty, (index) => {
    const medMapString = medMapsCounty[index],
      medMapId = medMapString.getAttribute('data-mapId'),
      medMapObj = window[medMapString.getAttribute('data-mapObj')];

    medCountyMap.init(
      medMapObj.countyGroups,
      medMapObj.groupData,
      medMapId,
      'by-county'
    );
  });
}

// ====---------------====
// Medicare tabs
// ====---------------====
const medicareTabs = function () {
  const _navbtns = document.querySelectorAll('a.mt__nav'),
    _navcontent = document.querySelectorAll('.mt__content'),
    // open tabs
    tabOpen = (element, id) => {
      let elAriaTitle = document
        .getElementById(id)
        .getAttribute('data-aria-title');

      document.getElementById('tabs-status').innerHTML =
        elAriaTitle + ' opened. Navigate to the content below.';

      if (!hasClass(element, 'active')) {
        let closeTab = new Promise((resolve) => {
          resolve(tabClose());
        });

        closeTab.then(() => {
          let opendelay = 0;
          let closedelay = 0;

          if (pglobals.mobile) {
            opendelay = pglobals.settings.speedOpen;
          }

          if (pglobals.mobile && hasClass(pglobals.body, 'tab-open')) {
            closedelay = pglobals.settings.speedClose;
          }

          setTimeout(() => {
            pglobals.body.classList.add('js-animate-in');
            element.classList.add('active');
            document.getElementById(id).classList.add('active');
            pglobals.body.classList.add('tab-open');

            setTimeout(() => {
              pglobals.body.classList.remove('js-animate-in');
            }, opendelay);
          }, closedelay);

          if (pglobals.mobile) {
            setTimeout(() => {
              let topOffset = element.getBoundingClientRect().top;
              window.scrollBy(0, topOffset - 53);
            }, 200);
          }
        });
      } else {
        if (pglobals.mobile) {
          tabClose();
        }
      }
    },
    // close tabs
    tabClose = () => {
      let closeSpeed = 0;

      // Check if tab is already open and adjust close speed accordioningly
      if (hasClass(pglobals.body, 'tab-open') && pglobals.mobile) {
        closeSpeed = pglobals.settings.speedClose;
      } else {
        closeSpeed = 0;
      }

      pglobals.body.classList.add('js-animate-out');

      setTimeout(() => {
        toggleClasses('remove', _navbtns, 'active');
        toggleClasses('remove', _navcontent, 'active');
        pglobals.body.classList.remove('tab-open');
        pglobals.body.classList.remove('js-animate-out');
      }, closeSpeed);
    };

  forEachAll(_navbtns, function (index) {
    if (hasClass(_navbtns[index], 'active')) {
      pglobals.body.classList.add('tab-open');
    }

    _navbtns[index].addEventListener('click', function (e) {
      e.preventDefault();

      let tabid = _navbtns[index].getAttribute('data-tab'),
        element = _navbtns[index];

      tabOpen(element, tabid);
    });
  });
};

if (document.querySelector('.medicare-tabs')) {
  medicareTabs();
}

// ====---------------====
// Medicare zip form
// ====---------------====
if (document.querySelector('.medicare-product-form')) {
  const mediZipArry = document.querySelectorAll('.medicare-product-form');

  const mediZipForm = {
    url: '',
    formEl: '',
    submitForm: function () {
      const submitEl = this.formEl.querySelector('input[type=submit]');

      submitEl.addEventListener('click', function () {
        let zipcode =
          mediZipForm.formEl.querySelector('input[type=text]').value;

        window.location.href = mediZipForm.url + zipcode;
      });
    },
    init: function (formEl) {
      this.formEl = formEl;
      this.url = formEl.getAttribute('data-submit-url');
      this.submitForm();
    },
  };

  forEachAll(mediZipArry, (index) => {
    let formEl = mediZipArry[index];
    mediZipForm.init(formEl);
  });
}

// ====---------------====
// Guide selector
// ====---------------====
if (document.querySelector('.guide-selector')) {
  const guideSelector = {
    // data
    selectwrap: '',
    dataId: '',
    dataObj: {},
    optionArry: [],
    optionHtml: '<option value="default">Select county</option>',
    buttonHtml: '',

    // create options
    createOptionArry: function (countyGroup, countyGroupId) {
      // Loop over county groups
      forEachAll(countyGroup, (index) => {
        this.optionArry.push({
          name: countyGroup[index],
          value: '#group-' + countyGroupId,
        });
      });
    },

    createOptionHtml: function () {
      // Sort the option array before making the HTML
      this.optionArry = this.optionArry.sort(function (a, b) {
        var nameA = a.name.toUpperCase();
        var nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });

      forEachAll(this.optionArry, (index) => {
        const county = this.optionArry[index];

        this.optionHtml += `<option value="${county.value}">${county.name}</option>`;
      });
    },

    // add slelect options to html
    makeSelect: function () {
      const select = this.selectwrap.querySelector('select');

      for (const group in this.dataObj.countyGroups) {
        this.createOptionArry(this.dataObj.countyGroups[group], group);
      }

      this.createOptionHtml();

      select.innerHTML = this.optionHtml;
    },

    // create buttons / groups for each kit
    createButtonGroups: function (groupArry, groupId) {
      let groupButtons = `<div id="group-${groupId}" class="gs__kit d-none">`;

      forEachAll(groupArry, (index) => {
        groupButtons += `<a href="${groupArry[index][0]}" class="btn btn-primary" target="_blank">${groupArry[index][1]}</a>`;
      });

      groupButtons += `</div>`;
      this.buttonHtml += groupButtons;
    },

    // add buttons / kits to page
    makeButtons: function () {
      const btnWrap = document.querySelector('.gs__btns');

      for (const group in this.dataObj.groupData) {
        this.createButtonGroups(this.dataObj.groupData[group], group);
      }

      btnWrap.innerHTML += this.buttonHtml;
    },

    // watch for select changes and show buttons
    showButtons: function () {
      const select = this.selectwrap.querySelector('select');
      const groupKits = document.querySelectorAll('.gs__kit');

      select.addEventListener('change', function (e) {
        e.preventDefault();

        forEachAll(groupKits, (index) => {
          groupKits[index].classList.add('d-none');
        });

        document.querySelector(this.value).classList.remove('d-none');
        document.querySelector('.gs__btns p').classList.remove('d-none');
      });
    },

    init: function (element) {
      this.selectwrap = element;
      this.dataId = this.selectwrap.getAttribute('data-selectData');
      this.dataObj = window[this.dataId];

      this.makeSelect();
      this.makeButtons();
      this.showButtons();
    },
  };

  guideSelector.init(document.querySelector('.guide-selector'));
}

// ====---------------====
// Plan tabs
// ====---------------====
if (document.querySelector('[data-toggle="plan-tabs"]')) {
  const planTabs = document.querySelectorAll('.pt__link');

  function ptOpen(tabid) {
    document
      .querySelector(`button[data-tabid="${tabid}"]`)
      .classList.add('active');
    document
      .querySelector(`button[data-tabid="${tabid}"]`)
      .setAttribute('aria-selected', 'true');

    document.querySelector(`#${tabid}`).classList.add('active');
    document.querySelector(`#${tabid}`).setAttribute('aria-expanded', 'true');
  }

  function ptClose() {
    forEachAll(planTabs, (index) => {
      const tab = planTabs[index];
      const id = tab.getAttribute('data-tabid');

      tab.classList.remove('active');
      tab.setAttribute('aria-selected', 'false');

      document.querySelector(`#${id}`).classList.remove('active');
      document.querySelector(`#${id}`).setAttribute('aria-expanded', 'false');
    });
  }

  function ptClick(element) {}

  forEachAll(planTabs, (index) => {
    const tab = planTabs[index];

    tab.addEventListener('click', () => {
      let id = tab.getAttribute('data-tabid');
      let state = tab.getAttribute('aria-selected');

      if (state != 'true') {
        ptClose();
        ptOpen(id);
      } else {
        ptClose();
      }
    });
  });
}

// ====---------------====
// Medicare countdown
// ====---------------====
if (document.querySelector('.mcb__countdown')) {
  // set current time and end date
  const mcbStart = new Date();
  const mcbEnd = new Date(2021, 9, 1);

  // get timer html elements
  const daysEl = document.querySelector('.mcb__days .counter');
  const hoursEl = document.querySelector('.mcb__hours .counter');

  // get the time difference
  function getDaysDif(start, end) {
    const oneDay = 1000 * 60 * 60; // calculates a day in miliseconds
    const diffInTime = end.getTime() - start.getTime(); // finds the difference in days between the start and end date in ms
    const diffInDays = diffInTime / oneDay; // converts diff in ms to hours
    const days = Math.floor(diffInDays / 24); // gets the round days from hours
    const hours = Math.floor(diffInDays % 24); // gets the remaining hours removing days

    // updates the html counter
    daysEl.textContent = days;
    hoursEl.textContent = hours;
  }

  // run get daysDif
  getDaysDif(mcbStart, mcbEnd);
}

// ------------------------------------------------
// Widget
// ------------------------------------------------
if (document.querySelector('.widget')) {
  const widget = document.querySelectorAll('.widget'),
    widgetLg = document.querySelector('.widget--lg'),
    widgetMed = document.querySelector('.widget--md'),
    widgetMedExpand = widgetMed.querySelector('.expand');

  // Hiding the large widget on sizes under 1024 to prevent things jamming together
  window.addEventListener('load', function () {
    if (this.window.innerWidth <= 939) {
      widgetLg.classList.add('hidden');
      widgetMed.classList.remove('hidden');
    }
  });

  window.addEventListener('resize', function () {
    if (
      this.window.innerWidth <= 939 &&
      !widgetLg.classList.contains('hidden')
    ) {
      widgetLg.classList.add('hidden');
      widgetMed.classList.remove('hidden');
    }
    if (
      this.window.innerWidth > 939 &&
      widgetLg.classList.contains('hidden') &&
      !widgetMed.classList.contains('widget--sm')
    ) {
      widgetLg.classList.remove('hidden');
      widgetMed.classList.add('hidden');
    }
  });

  // Lg widget collapse
  if (!widgetLg.classList.contains('hidden')) {
    const expandButton = widgetLg.querySelector('.expand');

    expandButton.addEventListener('click', function () {
      widgetLg.classList.add('minimize');

      setTimeout(() => {
        widgetLg.classList.add('hidden');
        widgetLg.classList.remove('minimize');
        widgetMed.classList.remove('hidden');
        widgetMed.classList.add('widget--sm');
      }, 250);
    });
  }

  // Medium widget collapse
  widgetMedExpand.addEventListener('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    if (!widgetMed.classList.contains('widget--sm')) {
      widgetMed.classList.remove('widget--md');
      widgetMed.classList.add('widget--sm');
      widgetMed.classList.add('minimize');
      setTimeout(() => {
        widgetMed.classList.remove('minimize');
      }, 1000);
    }
  });

  //looping through watching for click events on the widgets so if the small class is on it removes and adds the medium class
  forEachAll(widget, (index) => {
    widget[index].addEventListener('click', function () {
      if (
        window.innerWidth >= 940 &&
        widget[index].classList.contains('widget--sm')
      ) {
        widgetLg.classList.remove('hidden');
        widgetMed.classList.add('hidden');
        widgetLg.classList.add('maximize');

        setTimeout(() => {
          widgetLg.classList.remove('maximize');
        }, 1000);
      } else {
        if (widget[index].classList.contains('widget--sm')) {
          widget[index].classList.remove('widget--sm');
          widget[index].classList.add('widget--md');
          widget[index].classList.add('maximize');
          setTimeout(() => {
            widget[index].classList.remove('maximize');
          }, 1000);
        }
      }
    });
  });
}

// ====---------------====
// Form group with button to copy code
// ====---------------====
if (document.querySelector('.form-group--copy')) {
  function msgClassToggle(el, className) {
    const timing = 1500;

    // waits for msgEl to be appended then adds show
    setTimeout(() => {
      el.classList.add('show', className);
    }, 10);

    // let's the sucess message show for the timing length then removes the show class
    setTimeout(() => {
      el.classList.remove('show');
    }, timing);

    // gives the remove 50ms to finish the hide animation then removes the element
    setTimeout(() => {
      el.remove();
    }, timing + 50);
  }

  // ===------ Sets the message ------===
  function copyMessage(msg, form, status) {
    const msgEl = document.createElement('span');
    msgEl.innerText = msg;

    // appends the element to the form-group
    form.appendChild(msgEl);

    // checks the status and then returns the appropriate message
    if (status === 'bad') {
      msgClassToggle(msgEl, 'error');
    } else if (status === 'good') {
      msgClassToggle(msgEl, 'success');
    }
  }

  // ===------ finds copy inputs and adds a click listener ------===
  function copyCode() {
    const formGroups = document.querySelectorAll('.form-group--copy');

    formGroups.forEach((form) => {
      const inputVal = form.querySelector('input').value;
      const btn = form.querySelector('button');

      btn.addEventListener('click', () => {
        // Tries to write the code to the clipboads and returns a promise of sucess or failure
        navigator.clipboard.writeText(inputVal).then(
          function () {
            // If sucessfull this runs to show the copied message
            if (form.querySelector('span')) return false;
            copyMessage('Copied!', form, 'good');
          },
          function () {
            // Callback func for if clip failed
            copyMessage('Copied!', form, 'bad');
          }
        );
      });
    });
  }

  // copyCode();
}

//===-----------------===
// Community Events iframe URL updating
//===-----------------===
if (document.querySelector('.event-calendar')) {
  const updatedHeading = document.querySelector('#events-title');
  updatedHeading.innerHTML = 'Community Events';
  // getting the paramaters in the url
  const params = new URLSearchParams(window.location.search);
  // checking for the store paramater
  const store = params.get('store');
  //getting the iframe and its url
  const iframe = document.querySelector('.event-calendar');
  const iframeURL = iframe.src;
  //setting a new iframe url
  const newUrl = iframeURL + 'category/' + store + '/';
  //if there is a store paramater I am going to set the new url to the iframe
  if (store) {
    updatedHeading.innerHTML =
      'Community Events for ' +
      store.toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase());
    // setting the new iframe url
    iframe.setAttribute('src', newUrl);
    //setting the iframe title also to match the new url
    iframe.setAttribute(
      'title',
      'Community Events - ' +
        store.toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase())
    );
  }
}

//===-----------------===
// Document type check
//===-----------------===
const docTypes = ['.pdf', '.xlsx', '.doc', '.zip', '.csv'];

function checkDocumentType(doc) {
  //Looping throught the variables of differnt doctypes
  for (var i = 0; doc.length > i; i++) {
    //Finding each doctype and adding it to its own variable
    const docArray = document.querySelectorAll(
      '.content a[href*="' + doc[i] + '"]'
    );

    forEachAll(docArray, function (index) {
      const docType = doc[i].replace('.', '');
      const docTypeSpan = document.createElement('span');
      docTypeSpan.innerHTML = ' [' + docType + ']';
      //Adding a class that will style it the way we wish
      docTypeSpan.classList.add('file-type');
      docArray[index].setAttribute('title', '');
      docArray[index].setAttribute(
        'aria-label',
        docArray[index].innerText + ' ' + docType
      );
      //checking to see if the link doesnt contain the class external link and adding the class no-external so pdf's wont show linking disclaimer unless we want it to
      if (!docArray[index].classList.contains('external-link')) {
        docArray[index].classList.add('no-external');
      }
      //Checking to see if the link has the class list button because that determines where it will be inserted
      if (docArray[index].classList.contains('btn')) {
        docArray[index].appendChild(docTypeSpan);
      }
      // If element does not have the class list button
      else {
        // Checking to see if there is a next element sibling and making sure that if so its not a button
        if (
          docArray[index].nextElementSibling &&
          !docArray[index].nextElementSibling.classList.contains('btn')
        ) {
          // Checking to see if the next element sibling contains the class disclaimer if it does not adding the file-type class to existing span tags
          if (
            !docArray[index].nextElementSibling.classList.contains('disclaimer')
          ) {
            docArray[index].nextElementSibling.classList.add('file-type');
          }
          //If there is a disclaimer adding the doctype right after element
          else {
            docArray[index].insertAdjacentElement('afterend', docTypeSpan);
          }
        }
        //adding the span tag after the element if there is no sibling
        else {
          docArray[index].insertAdjacentElement('afterend', docTypeSpan);
        }
      }
    });
  }
  return;
}

checkDocumentType(docTypes);

//===-----------------===
// External link notification
//===-----------------===
function externalLinkNotification() {
  // Gathering all links with target=_blank
  const externalLinks = document.querySelectorAll(
    '.content a[target="_blank"]'
  );

  forEachAll(externalLinks, function (index) {
    var link = externalLinks[index];
    // Checking for the no-external class since we dont want an external linking icon/alert for some links
    if (!link.classList.contains('no-external')) {
      link.classList.add('external-link');
      //Creating the span for the notifications
      const screenReaderNotfication = document.createElement('span');

      screenReaderNotfication.innerHTML =
        '&nbsp;-&nbsp;will open in a new tab.';
      screenReaderNotfication.classList.add('sr-only');
      // Adding the notification span to the link so it will read to the users after the link text is read
      link.appendChild(screenReaderNotfication);
    }
  });
}

externalLinkNotification();

//===-----------------===
// Search results annoucements
//===-----------------===
if (document.getElementById('cludo-search-results')) {
  const searchText = document.getElementById('main-seach-status');
  searchText.innerHTML = document.querySelector(
    '.search-result-count'
  ).innerHTML;
}

//===-----------------===
// Accordion announcements
//===-----------------===
if (document.querySelector('.card')) {
  const accordionHeaders = document.querySelectorAll('.card-header');

  // setting an annoucment to let user know which accordion is open
  accordionHeaders.forEach((element) => {
    if (element.getAttribute('role') === 'tab') {
      const status = element.querySelector('a');
      status.addEventListener('click', () => {
        if (status.classList.contains('collapsed')) {
          document.getElementById('accordion-status').innerText =
            status.innerText + ' accordion opened';
        } else {
          document.getElementById('accordion-status').innerText = '';
        }
      });
    }
  });
}
// Maintain focus inside the menu
function maintainFocus(elements) {
  elements.forEach((element) => {
    const el = document.querySelector(element),
      focusableElements =
        '[href], [tabindex]:not([tabindex="-1"]), input, button',
      firstFocusableElement = el.querySelectorAll(focusableElements)[0],
      // get first element to be focused inside element
      focusableContent = el.querySelectorAll(focusableElements),
      lastFocusableElement = focusableContent[focusableContent.length - 1];
    // get last element to be focused inside element
    document.addEventListener('keyup', function (e) {
      let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
      if (!isTabPressed) {
        return;
      }
      if (e.shiftKey) {
        // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus(); // add focus for the last focusable element
          e.preventDefault();
        }
      }
    });
    lastFocusableElement.addEventListener('focus', function () {
      lastFocusableElement.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      });
    });
  });
}

if (document.querySelector('.site-menu')) {
  maintainFocus(['.site-menu', '.site-search', '.sign-in']);
}

//===-----------------===
// Accordion on mobile
//===-----------------===
if (document.querySelector('.js-mobile-open')) {
  const accordionWrapper = document.querySelectorAll('.js-mobile-open');

  if (window.innerWidth <= 768) {
    const firstAccordionList = accordionWrapper[0],
      accordionList = firstAccordionList.querySelectorAll('#accordion .card'),
      firstAccordion = accordionList[0],
      firstAccordionBtn = firstAccordion.querySelector('.card-header a'),
      firstAccordionPanel = firstAccordion.querySelector(
        `${firstAccordionBtn.getAttribute('href')}`
      );

    firstAccordion.setAttribute('aria-expanded', 'true');
    firstAccordionPanel.classList.add('show');
  }
}
